import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/appData";
import { apiGetAllEmployees } from "../../../services/EmployeeService";
import { Employee } from "winslow-core";

interface EmployeeDataState {
  employees: Employee[];
  loading: boolean;
  error: string | null;
}

export const useEmployeeData = (isAuthenticated: boolean) => {
  const storeUser = useSelector(selectUser);
  const [state, setState] = useState<EmployeeDataState>({
    employees: [],
    loading: true,
    error: null,
  });

  const fetchEmployees = useCallback(async () => {
    if (!isAuthenticated) {
      setState({ employees: [], loading: false, error: null });
      return;
    }

    if (!storeUser?.currentWorkspaceId) {
      setState({
        employees: [],
        loading: false,
        error: "No workspace selected",
      });
      return;
    }

    try {
      setState((prev) => ({ ...prev, loading: true, error: null }));
      const employeesData = await apiGetAllEmployees(
        storeUser.currentWorkspaceId
      );

      setState({
        employees: employeesData || [],
        loading: false,
        error: null,
      });
    } catch (err) {
      console.error("Error fetching employees:", err);
      setState({
        employees: [],
        loading: false,
        error: "Failed to load employees",
      });
    }
  }, [isAuthenticated, storeUser?.currentWorkspaceId]);

  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  const reload = useCallback(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  return {
    ...state,
    reload,
  };
};
